import * as React from "react";
const SvgAgentClientIcon = ({ color }) => (
  <svg width={23} height={20} fill="none">
    <path
      stroke={color}
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={2}
      d="M17.499 13.837c1.456.731 2.704 1.905 3.615 3.373.18.29.27.436.302.637.063.409-.216.912-.597 1.073-.188.08-.398.08-.82.08m-4.5-9.468a4.5 4.5 0 0 0 0-8.064m-2 4.032a4.5 4.5 0 1 1-9 0 4.5 4.5 0 0 1 9 0ZM2.059 16.938C3.651 14.545 6.168 13 8.998 13s5.346 1.545 6.94 3.938c.35.525.525.787.505 1.122-.016.26-.187.58-.395.738-.268.202-.636.202-1.372.202H3.32c-.736 0-1.104 0-1.372-.202a1.11 1.11 0 0 1-.395-.738c-.02-.335.155-.597.504-1.122Z"
    />
  </svg>
);
export default SvgAgentClientIcon;
